// src/components/NoticeBoard.js
import React from 'react';
import '../css/NoticeBoard.css';
const NoticeBoard = () => {
  return (
    <section className="notice-board">
      <div className="container h2">
        <h2>Notice, Tenders And Other Information</h2>
        
        <div className="notice-sections">
          <div className="notice-category">
            <h3>General Notice</h3>
            <ul>
              <li>Regarding 75% Attendance <span>05-06-2025</span></li>
              <li>SPOKEN TUTORIAL - IIT</li>
            </ul>
            <button className="view-all">View All</button>
          </div>
          
          <div className="notice-category">
            <h3>Tender Notice</h3>
            <ul>
              <li>No notices currently</li>
            </ul>
            <button className="view-all">View All</button>
          </div>
          
          <div className="notice-category">
            <h3>Examination Notice</h3>
            <ul>
              <li>NOTICE REGARDING PRACTICAL EXAM FOR ZOOLOGY PART III</li>
            </ul>
            <button className="view-all">View All</button>
          </div>
          
          <div className="notice-category">
            <h3>Admission Notice</h3>
            <ul>
              <li>NOTICE REGARDING FOR UG 4TH SEMESTER ADMISSION (2023-)</li>
            </ul>
            <button className="view-all">View All</button>
          </div>
        </div>
        
      
      </div>
    </section>
  );
};

export default NoticeBoard;